export default __webpack_public_path__ + "static/AntiBullying_Policy-7fb0a13954e9820c35ac50c45f5f2450.pdf";